import { MediaQueryChangeEvent, MediaQueryService } from '@workbench/core';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

// TODO: remove this composable and use viewport.util from UI package instead,
//  or move it to UI package as a reactive wrapper for the util to avoid using onWindowResize in each component

export const useBreakpoint = () => {
  const mediaQueryService = new MediaQueryService(window);

  const breakpoint = ref(mediaQueryService.getCurrentMediaQuery());

  const isMobile = computed(() => ['mq1', 'mq2', 'mq3'].includes(breakpoint.value));
  const isDesktop = computed(() => !isMobile.value);

  const setBreakpoint = ({ detail }: CustomEvent<MediaQueryChangeEvent>) => (breakpoint.value = detail.current);

  onMounted(() => {
    window.addEventListener('wbresize', setBreakpoint as any);
    mediaQueryService.observe();
  });

  onBeforeUnmount(() => {
    window.removeEventListener('wbresize', setBreakpoint as any);
    mediaQueryService.disconnect();
  });

  return { breakpoint, isMobile, isDesktop };
};
